import {defineStore} from 'pinia'
import {deleteCodeByIdentifier, deleteCodeByIdentifiers} from "@/scripts/api/codes";

export const qrCodeListStore = defineStore('qrCodeFormStore', {
    state: () => ({
        list: [],
        loading: false,
        cursor: null,
        isCompleted: false
    }),
    actions: {
        async loadList() {
            this.loading = true

            let params = ''
            if (this.cursor) {
                params = new URLSearchParams({
                    cursor: this.cursor,
                });
            }

            const response = await axios.get(`/api/qrcode?${params}`);

            if (response.data.list.length < 10) {
                this.isCompleted = true
            }

            this.list.push(...response.data.list)
            this.cursor = response.data.cursor
            this.loading = false
        },

        async deleteByIdentifier(identifier) {
            await deleteCodeByIdentifier(identifier)
            let i = this.list.map(item => item.identifier).indexOf(identifier)
            this.list.splice(i, 1);
        },

        async deleteByIdentifiersList(identifiers) {
            await deleteCodeByIdentifiers(identifiers)
            identifiers.forEach(identifier => {
                let i = this.list.map(item => item.identifier).indexOf(identifier)
                this.list.splice(i, 1);
            })
        }
    }
})
